import { render } from "./modal_menu.vue?vue&type=template&id=2c890462&scoped=true"
import script from "./modal_menu.vue?vue&type=script&lang=js"
export * from "./modal_menu.vue?vue&type=script&lang=js"

import "./modal_menu.vue?vue&type=style&index=0&id=2c890462&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c890462"]])

export default __exports__